import React from 'react';

const EmailFormatCustom = React.forwardRef(function EmailFormatCustom(props, ref) {
    const { onChange, name, ...other } = props;

    return (
        <input
            {...other}
            ref={ref}
            onChange={(e) => {
                // Normalize the email address: convert to lowercase and trim whitespace
                const normalizedValue = e.target.value.toLowerCase().trim();
                if (onChange) {
                    onChange({
                        target: {
                            name: name,
                            value: normalizedValue,
                        },
                    });
                }
            }}
        />
    );
});

export default EmailFormatCustom;
